<template>
  <div>
    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12 col-md-8">
            <multiselect v-model="selected_organisation"
                         :options="organisations"
                         placeholder="Select an organisation..."
                         :allow-empty="false"
                         label="name"
                         track-by="uuid"
                         @select="getUserCustomerTableData" />
          </div>
          <div class="col-12 col-md-4">
            <create-organisation-modal />
          </div>
        </div>
      </div>
    </div>

    <div v-if="selected_organisation" class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Name</label>
              <input v-model="selected_organisation.name" type="text" class="form-control">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Slug</label>
              <input v-model="selected_organisation.slug" type="text"
                     class="form-control"
                     disabled>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Uuid</label>
              <input v-model="selected_organisation.uuid" type="text"
                     class="form-control"
                     disabled>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-3">
            <label>FreshSales Account</label>
            <div class="input-group kt-input-group kt-input-group--square">
              <multiselect v-if="sales_accounts && sales_accounts.length" v-model="selected_sales_account"
                           :options="sales_accounts"
                           label="name"
                           track-by="id"
                           :allow-empty="false"
                           :allow-mutiple="false"
                           :close-on-select="true"
                           placeholder="Select FreshSales Account" />
              <button type="button" class="btn btn-link p-0 m-0 d-inline align-baseline" @click.prevent="getSalesAccounts(true)">
                Refresh
              </button>
            </div>
          </div>
          <div class="col-12 col-md-6  mt-3">
            <div v-if="selected_sales_account">
              <label>FreshSales Data</label>
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{{ selected_sales_account.id }}</td>
                  </tr>
                  <tr>
                    <td>Company Name</td>
                    <td>{{ selected_sales_account.name }}</td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <a :href="`https://sharpstream.freshsales.io/accounts/${selected_sales_account.id}`" target="_blank" class="btn btn-sm btn-ss">View in FreshSales</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <a href="javascript:;" class="btn btn-ss-standout" @click="updateOrganisation">Update</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="shouldShowTable" class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12">
            <user-customer-table :organisation-uuid="selected_organisation.uuid" :organisation-users="organisation_users" :customers-with-users="customers_with_users" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="selected_organisation && !shouldShowTable" class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12">
            <h5 v-if="!loading">
              No customers assigned to this organisation.
            </h5>
            <h5 v-else>
              Loading...
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserCustomerTable from "VuePartials/App/Organisations/UserCustomerTable";
import CreateOrganisationModal from "VuePartials/Admin/VJSModals/CreateOrganisationModal";

export default {
  components: { UserCustomerTable, CreateOrganisationModal },
  data() {
    return {
      customers_with_users: [],
      organisation_users: [],
      selected_organisation: null,
      organisations: window.organisations,
      loading: false,
      sales_accounts: [],
      selected_sales_account: null,
    };
  },
  computed: {
    shouldShowTable() {
      return this.organisations.length
          && this.selected_organisation
          && this.selected_organisation.uuid
          && this.customers_with_users.length
          && this.organisation_users;
    },
  },
  mounted() {
    const vm = this;
    EventBus.$on("organisation-added", (payload) => {
      vm.organisations.push(payload);
    });

    this.getSalesAccounts();
  },
  methods: {
    getSalesAccounts(fresh = false) {
      axios.get('/api/v1/admin/fresh-sales/unused-sales-accounts', {
        params: { fresh: fresh },
      }).then((response) => {
        this.sales_accounts = response.data.data;
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    getUserCustomerTableData(selection) {
      this.organisation_users = [];
      this.customers_with_users = [];
      this.loading = true;
      axios.get(`/api/v1/admin/organisation/${selection.uuid}`).then((response) => {
        this.organisation_users = response.data.data.organisation_users;
        this.customers_with_users = response.data.data.customers_with_users;
        this.loading = false;
        this.selected_sales_account = null;
        Vue.nextTick(() => {
          this.getCurrentSalesAccount();
        });
      }).catch((error) => {
        window.handleAxiosError(error);
        this.loading = false;
      });

      this.getCurrentSalesAccount();
    },

    async getCurrentSalesAccount(fresh = false) {
      if (!this.selected_organisation?.provider_id) {
        return null;
      }
      try {
        const response = await axios.get('/api/v1/admin/fresh-sales/sales-account-by-id', {
          params: {
            'provider_id': this.selected_organisation.provider_id,
            'fresh': fresh,
          },
        });

        if (response) {
          this.selected_sales_account = response.data.data.sales_account;
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },

    updateOrganisation() {
      axios.patch(`/api/v1/admin/organisation/${this.selected_organisation.uuid}`, {
        name: this.selected_organisation.name,
        provider_id: this.selected_sales_account.id,
      }).then((response) => {
        toastr.success("Updated Organisation.");
        const updated_organisation = response.data.data;
        let organisation_to_update = _.find(this.organisations, organisation => organisation.uuid === updated_organisation.uuid);
        organisation_to_update = JSON.parse(JSON.stringify(updated_organisation));
        this.selected_organisation = organisation_to_update;
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },
};
</script>
